__turbopack_context__.v({
  "subtitle": "EventTags-module-scss-module___3wa6a__subtitle",
  "tagsContainer": "EventTags-module-scss-module___3wa6a__tagsContainer",
  "title": "EventTags-module-scss-module___3wa6a__title",
  "titleWithoutSubtitle": "EventTags-module-scss-module___3wa6a__titleWithoutSubtitle",
  "wrapper": "EventTags-module-scss-module___3wa6a__wrapper",
});
